<script>
export default {
  setup() {
    return {
      bios: [
        {
          id: 1,
          bio: "I’m a Software Engineer with 3+ years of experience in software development. I enjoy discussing engineering ideas, problem-solving approaches, and the way technology shapes real-world systems. I like thinking beyond code as well, especially about how software decisions influence products, teams, and future growth.",
        },
        {
          id: 2,
          bio: "My long-term goal is to grow into a CTO role, and I’m actively building myself in that direction. I can also work on AI integrations and build AI chatbot solutions, and I’m currently especially interested in learning and working more deeply with AI, machine learning, and robotics.",
        },
      ],
      highlights: [
        {
          id: 1,
          value: "10+",
          label: "Web Applications",
        },
        {
          id: 2,
          value: "5+",
          label: "Mobile Applications",
        },
        {
          id: 3,
          value: "20+",
          label: "Automation Flows",
        },
        {
          id: 4,
          value: "50+",
          label: "Websites Built",
        },
      ],
    };
  },
};
</script>

<template>
  <div
    class="w-full flex flex-col justify-center align-middle md:justify-between items-center md:flex-row gap-10 sm:gap-10">
    <!-- About profile image -->
    <div class="w-full md:w-[30%] mt-7 mb-7 md:my-0 text-center">
      <img
        src="@/assets/images/profile.webp"
        class="rounded-xl w-full max-w-sm mx-auto shadow"
        alt="" />
    </div>

    <!-- About details -->
    <div
      class="w-full md:w-[70%] text-left bg-white dark:bg-ternary-dark px-6 py-5 rounded-xl h-full flex flex-col justify-center">
      <p
        v-for="bio in bios"
        :key="bio.id"
        class="font-general-regular mb-4 text-ternary-dark dark:text-white text-md lg:text-lg tracking-wide leading-relaxed font-medium"
        v-html="bio.bio"></p>

      <div class="grid grid-cols-2 lg:grid-cols-4 gap-4 mt-3">
        <div
          v-for="item in highlights"
          :key="item.id"
          class="rounded-lg border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800/60 px-4 py-4 text-center">
          <h3
            class="text-xl lg:text-2xl font-bold text-ternary-dark dark:text-white">
            {{ item.value }}
          </h3>
          <p
            class="mt-1 text-sm lg:text-base text-slate-600 dark:text-slate-300 font-medium">
            {{ item.label }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
